"use client";

import { useSession } from "@/lib/auth/auth-client";

/**
 * Hook to get the current authenticated user.
 * Uses Better Auth session - automatically syncs with server.
 */
export function useUser() {
  const { data: session, isPending } = useSession();

  return {
    user: session?.user ?? null,
    loading: isPending,
  };
}
